import { PENDING, FULFILLED, REJECTED } from "redux-promise-middleware";
import {
  FETCH_PRODUCT_STATUSES,
  FETCH_PRODUCT_STATUS,
  CREATE_PRODUCT_STATUS,
  UPDATE_PRODUCT_STATUS,
  DELETE_PRODUCT_STATUS
} from "../actions/productStatus";

const SINGLE_DATA_INITIAL_STATE = {
  data: {},
  error: null,
  loading: false
};
const MULTI_DATA_INITIAL_STATE = {
  data: [],
  error: null,
  loading: false
};

export function productStatuses(state = MULTI_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${FETCH_PRODUCT_STATUSES}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_PRODUCT_STATUSES}_${FULFILLED}`:
      return Object.assign({}, state, payload.data, {
        loading: false,
        error: null
      });
    case `${FETCH_PRODUCT_STATUSES}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function productStatus(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${FETCH_PRODUCT_STATUS}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_PRODUCT_STATUS}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${FETCH_PRODUCT_STATUS}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function createProductStatus(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${CREATE_PRODUCT_STATUS}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${CREATE_PRODUCT_STATUS}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${CREATE_PRODUCT_STATUS}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function updateProductStatus(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${UPDATE_PRODUCT_STATUS}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${UPDATE_PRODUCT_STATUS}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${UPDATE_PRODUCT_STATUS}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function deleteProductStatus(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${DELETE_PRODUCT_STATUS}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${DELETE_PRODUCT_STATUS}_${FULFILLED}`:
      return Object.assign({}, state, { data: payload.data }, { loading: false, error: null });
    case `${DELETE_PRODUCT_STATUS}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/productStatus.js